import React, {Fragment} from "react";
import Select from "../../../../form/Select";
import classNames from "classnames";
import AddressControl from "../../../../form/AddressControl";
import Barcoder from "../../../../../utils/barcoder";
import {AgentSelect, BarcodeFormatter, CurrencyFormatter} from "../../../../../utils/formatters";
import TextInput from "../../../../form/TextInput";
import ComponentConfig from "../../../../form/ComponentConfig";
import {loadComponent} from "../../../../../utils/components";
import debounce from "../../../../../utils/debounce";
import Button from "../../../../form/Button";
import MembercardEditor from "../../../MembercardEditor";
import ModalEditor from "../../../ModalEditor";

const validator = new Barcoder('ean13');

class MemberCardComponent extends React.Component {

    saveMemberCard = debounce((field, barcode) => {
        this.loadMembercard && this.loadMembercard.abort();
        barcode = barcode || '';
        if (barcode.length === 12) {
            barcode = "0" + barcode;
        }
        let membercard = this.props.values?.membercard;
        let agent = this.props.values?.agent;
        if ((barcode + '').length === 13 && validator.validate(barcode)) {
            this.loadMembercard = loadComponent("membercard", {
                filter: [{field: "barcode", value: barcode}],
                view: ["id", "barcode", "user"],
            });
            this.loadMembercard.then((membercard) => {
                if (membercard.id) {
                    this.props.setFormValues({...this.props.values, membercard, agent: membercard.user});
                } else {
                    this.props.setFormValues({...this.props.values, membercard: {barcode}});
                }
            });
        } else if (!barcode) {
            if (membercard?.user?.id === agent?.id) {
                this.props.setFormValues({...this.props.values, membercard: {barcode}, agent: null});
            } else {
                this.props.setFormValues({...this.props.values, membercard: {barcode}});
            }
        }
    }, 300);

    render() {
        const agent = this.props?.values?.agent;
        const membercard = this.props?.values?.membercard;
        return <div className="row">
            <div className="col-md-2">
                {membercard?.id ? <Select
                    storeType="remote"
                    component="membercard"
                    label="Vevőkártya"
                    name="membercard"
                    labelKey="barcode"
                    valueKey="barcode"
                    view={["id", "barcode", "user"]}
                    isClearable={true}
                    value={membercard}
                    searchFormatter={(input) => {
                        let barcode = BarcodeFormatter(input);
                        if (!isNaN(barcode)) {
                            barcode = barcode + '';
                            if (input.length === 12) {
                                while (barcode.length < 13) {
                                    barcode = '0' + barcode;
                                }
                            } else {
                                barcode = input;
                            }
                        } else {
                            barcode = input;
                        }
                        if (barcode.length < 13) {
                            return '';
                        }
                        return barcode;
                    }}
                    saveChanges={(field, newmembercard) => {
                        if (membercard?.user?.id === agent?.id) {
                            this.props.setFormValues({...this.props.values, membercard: newmembercard, agent: newmembercard?.user || null});
                        } else {
                            this.props.setFormValues({...this.props.values, membercard: newmembercard});
                        }
                    }}
                    autoSelect={true}
                    onLoadCompleted={(options, barcode) => {
                        if (options.length === 0) {
                            barcode = barcode || '';
                            if (barcode.length === 12) {
                                barcode = "0" + barcode;
                            }
                            if (validator.validate(barcode)) {
                                this.props.setFormValues({...this.props.values, membercard: {barcode}, agent: null});
                            }
                        }
                    }}
                /> : <TextInput
                    label="Vevőkártya"
                    name="membercard.barcode"
                    type="number"
                    value={membercard?.barcode}
                    saveChanges={this.saveMemberCard}
                />}
            </div>
            {!membercard?.id || (membercard?.id && membercard?.user) ?
                <Fragment>
                    <div className={classNames({
                        "col-md-3": agent,
                        "col-md-10": !agent
                    })}>
                        <Select
                            label="Vevő"
                            name="agent"
                            component="user"
                            isClearable={true}
                            objectValue={true}
                            optionsTemplate={AgentSelect}
                            labelKey="name"
                            searchtype="member"
                            {...this.props.getFieldProps("agent")}
                            storeType="remote"
                            value={agent}
                            disabled={!!membercard?.user}
                            searchFormatter={(input) => {
                                input = BarcodeFormatter(input);
                                if (!isNaN(input)) {
                                    input = input + '';
                                    while (input.length < 13) {
                                        input = '0' + input;
                                    }
                                }
                                return input;
                            }}
                            saveChanges={(field, agent) => {
                                this.props.setFormValues({...this.props.values, agent});
                            }}
                            autoSelect={true}
                            onLoadCompleted={(options, barcode) => {
                                if (barcode === undefined) {
                                    return options;
                                }
                                barcode = barcode || '';
                                if (options.length === 0) {
                                    if (barcode.length === 12) {
                                        barcode = "0" + barcode;
                                    }
                                    if (validator.validate(barcode)) {
                                        this.props.setFormValues({...this.props.values, agent: null, membercard: {barcode}});
                                    } else {
                                        this.props.setFormValues({...this.props.values, agent: null, membercard: null});
                                    }
                                }
                            }}
                        />
                    </div>
                    {agent &&
                        <div className="col-md-7">
                            <div className="row">
                                <AddressControl
                                    disabled={"disabled"}
                                    value={agent.address}
                                    label="Cím"
                                />
                            </div>
                        </div>
                    }
                </Fragment>
                :
                <Fragment>
                    <MembercardEditor
                        editor={ModalEditor}
                        other={() => null}
                        selection={null}
                        list={(listProps) => {
                            return <Fragment>
                                <div className="col-md-10">
                                    <div className="row">
                                        <label className="control-label">&nbsp;</label>
                                        <Button
                                            color="default"
                                            block={true}
                                            onClick={() => {
                                                listProps.loadForm({id: membercard?.id});
                                            }}
                                        >
                                            Vevőkártya hozzárendelés vevőhöz
                                        </Button>
                                    </div>
                                </div>
                            </Fragment>;
                        }}
                        saveForm={async (data, componentConfig, editorProps) => {
                            this.props.setFormValues({...this.props.values, agent: data.user, membercard: {...membercard, ...data}});
                            await editorProps.setFormValues({});
                        }}
                    />
                </Fragment>
            }
        </div>;
    }
}

class AgentComponent extends React.Component {

    render() {
        const agent = this.props.values?.agent;
        return <div className="row">
            <div className={classNames({
                "col-md-3": agent,
                "col-md-12": !agent
            })}>
                <Select
                    label="Vevő"
                    name="agent"
                    component="user"
                    isClearable={true}
                    objectValue={true}
                    optionsTemplate={AgentSelect}
                    labelKey="name"
                    searchtype="member"
                    {...this.props.getFieldProps("agent")}
                    storeType="remote"
                    value={agent}
                    searchFormatter={(input) => {
                        input = BarcodeFormatter(input);
                        if (!isNaN(input)) {
                            input = input + '';
                            while (input.length < 13)
                                input = '0' + input;
                        }
                        return input;
                    }}
                    saveChanges={(field, agent) => {
                        this.props.setFormValues({...this.props.values, agent, membercard: null});
                    }}
                    autoSelect={true}
                    onLoadCompleted={(options, barcode) => {
                        if (barcode === undefined) {
                            return options;
                        }
                        barcode = barcode || '';
                        if (options.length === 0) {
                            if (barcode.length === 12) {
                                barcode = "0" + barcode;
                            }
                            if (validator.validate(barcode)) {
                                this.props.setFormValues({...this.props.values, agent: null, membercard: barcode});
                            } else {
                                this.props.setFormValues({...this.props.values, agent: null, membercard: null});
                            }
                        }
                    }}
                />
            </div>
            {agent && <Fragment>
                <div className={classNames({"col-md-9": !this.props.userConfig.fielddefs.purchasetotal, "col-md-7": !!this.props.userConfig.fielddefs.purchasetotal})}>
                    <div className={"row"}>
                        <AddressControl
                            disabled={"disabled"}
                            value={agent.address}
                            label="Cím"
                        />
                    </div>
                </div>
                <div className="col-md-2 currency">
                    <TextInput
                        value={agent.purchasetotal}
                        formatter={CurrencyFormatter}
                        disabled={true}
                        label="Összes vásárlása"
                    />
                </div>
            </Fragment>}
        </div>;
    }
}

const MemberCard = (propsTop) => {
    if (propsTop.values?.membercard_system) {
        return <ComponentConfig componentName="user" componentConfigAs="userConfig">
            <MemberCardComponent {...propsTop} />
        </ComponentConfig>
    } else {
        return <ComponentConfig componentName="user" componentConfigAs="userConfig">
            <AgentComponent {...propsTop} />
        </ComponentConfig>
    }
}

export default MemberCard;